import React, { useContext, useState, useMemo, Fragment } from 'react';
import classNames from 'classnames/bind';
import WhereBuyIcon from 'media/icons/where-buy.icon.svg';
import WhereFixIcon from 'media/icons/where-fix.icon.svg';
import { withErrorBoundary } from 'containers/ErrorBoundary';
import { StaticTextContext } from 'context/StaticTextContext';

import styles from './DealerLocator.module.scss';
const cx = classNames.bind(styles);

const DealerLocator = () => {
  const { labels } = useContext(StaticTextContext);
  const [{ whereToFixURL, whereToBuyURL }] = useState(
    window.dealerLocator || {}
  );

  const { dealerLocator } = labels;
  const whereToFixLabel = useMemo(() => (dealerLocator && dealerLocator.whereToFix) || 'Where to fix', []);
  const whereToBuyLabel = useMemo(() => (dealerLocator && dealerLocator.whereToBuy) || 'Where to buy', []);

  return (
    <Fragment>
      {whereToFixURL && (
        <a className={cx('btn')} href={whereToFixURL}>
          <span className={cx('btn-icon')}>
            <WhereFixIcon />
          </span>
          <span className={cx('btn-text')}>{whereToFixLabel}</span>
        </a>
      )}
      {whereToBuyURL && (
        <a className={cx('btn')} href={whereToBuyURL}>
          <span className={cx('btn-icon')}>
            <WhereBuyIcon />
          </span>
          <span className={cx('btn-text')}>{whereToBuyLabel}</span>
        </a>
      )}
    </Fragment>
  );
};

export default withErrorBoundary(DealerLocator);



// WEBPACK FOOTER //
// ./src/components/DealerLocator/DealerLocator.js